import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import { SEARCH_ITEM_GUTTER } from '@/scripts/config';
import { Button, Card, Col, Form, Input, message, Row, Space, Table, Select } from 'antd';
import { createJsonOptions } from '@/scripts/utils';
import { useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';

const API_BASE = 'http://183.249.91.105:15600';
const pageKey = 'OneOrderList'; // 页面身份

// 日期格式化辅助
const formatDateTime = (v) => (v ? dayjs(v).format('YYYY-MM-DD HH:mm:ss') : '-');
const formatDate = (v) => (v ? dayjs(v).format('YYYY-MM-DD') : '-');

export default function OneOrderList() {
    const [dataSource, setDataSource] = useState([]); // 当前展示的数据
    const [allData, setAllData] = useState([]); // 全量数据（前端筛选用）
    const [loading, setLoading] = useState(false);
    const [tableScrollY, setTableScrollY] = useState(600);
    const [formSearch] = Form.useForm();

    const { data: startPortOptions } = useGetStartPortQuery(1);
    const { data: endPortOptions } = useGetEndPortQuery(1);

    // 拉取列表
    const loadingData = () => {
        setLoading(true);
        axios
            .get(`${API_BASE}/one/contracts`)
            .then((res) => {
                // 兼容多种返回结构：数组 / { items: [] } / { data: [] }
                const list = Array.isArray(res.data) ? res.data : res.data?.items || res.data?.data || [];
                setAllData(list);
                setDataSource(list);
            })
            .catch((err) => {
                console.error(err);
                message.error('获取订单列表失败');
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadingData();
        const updateHeight = () => {
            setTableScrollY(window.innerHeight - 400);
        };
        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    // 前端搜索
    const handleSearch = () => {
        const { start_port_name, end_port_name, booking_number } = formSearch.getFieldsValue();

        let filtered = [...allData];

        if (start_port_name) {
            const kw = String(start_port_name).trim().toLowerCase();
            filtered = filtered.filter((item) =>
                String(item.start_port_name || '')
                    .toLowerCase()
                    .includes(kw),
            );
        }

        if (end_port_name) {
            const kw = String(end_port_name).trim().toLowerCase();
            filtered = filtered.filter((item) =>
                String(item.end_port_name || '')
                    .toLowerCase()
                    .includes(kw),
            );
        }

        if (booking_number) {
            const kw = String(booking_number).trim().toLowerCase();
            filtered = filtered.filter((item) =>
                String(item.booking_number || '')
                    .toLowerCase()
                    .includes(kw),
            );
        }

        setDataSource(filtered);
    };
    const formatAmount = (v) => {
        if (v === null || v === undefined || v === '') return '-';
        const num = Number(v);
        return Number.isNaN(num) ? '-' : num.toFixed(2);
    };
    // 重置
    const handleReset = () => {
        formSearch.resetFields();
        setDataSource(allData);
    };

    const columns = [
        {
            title: '起始港',
            dataIndex: 'start_port_name',
            width: 140,
            ellipsis: true,
            render: (text) => text || '-',
        },
        {
            title: '目的港',
            dataIndex: 'end_port_name',
            width: 140,
            ellipsis: true,
            render: (text) => text || '-',
        },
        {
            title: '账号',
            dataIndex: 'account_name',
            width: 140,
            ellipsis: true,
            render: (text) => text || '-',
        },
        {
            title: '海运费',
            dataIndex: 'ocean_freight_amount',
            width: 140,
            ellipsis: true,
            render: (text) => formatAmount(text),
        },
        {
            title: '折扣',
            dataIndex: 'promotion_amount',
            width: 140,
            ellipsis: true,
            render: (text) => formatAmount(text),
        },
        {
            title: '总价',
            dataIndex: 'total_amount',
            width: 140,
            ellipsis: true,
            render: (text) => formatAmount(text),
        },
        {
            title: '船名航次',
            dataIndex: 'vessel_name',
            width: 240,
            ellipsis: true,
            render: (_, record) => {
                const vessel = record?.vessel_name || record?.vesselName || '-';
                const voyage = record?.voyage_no || record?.voyageNo || '-';
                return `${vessel} | ${voyage}`;
            },
        },
        {
            title: 'departure_date',
            dataIndex: 'departure_date',
            width: 120,
            render: (text) => formatDate(text),
        },
        {
            title: 'arrival_date',
            dataIndex: 'arrival_date',
            width: 120,
            render: (text) => formatDate(text),
        },
        {
            title: 'booking_number',
            dataIndex: 'booking_number',
            width: 150,
            ellipsis: true,
            render: (text) => text || '-',
        },
        {
            title: 'contract_no',
            dataIndex: 'contract_no',
            width: 150,
            ellipsis: true,
            render: (text) => text || '-',
        },
        {
            title: 'created_at',
            dataIndex: 'created_at',
            width: 170,
            render: (text) => formatDateTime(text),
        },
        {
            title: 'booking_submitted_at',
            dataIndex: 'booking_submitted_at',
            width: 170,
            render: (text) => formatDateTime(text),
        },
        {
            title: 'option_id',
            dataIndex: 'option_id',
            width: 120,
            ellipsis: true,
            render: (text) => text || '-',
        },
        {
            title: 'trace_id',
            dataIndex: 'trace_id',
            width: 300,
            // ellipsis: true,
            render: (text) => text || '-',
        },
    ];

    return (
        <div className="list">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <PageHeader title="One 订单列表" sticky></PageHeader>
            </div>

            <Card className="ax-search-card">
                <Form form={formSearch} className="formStyle" autoComplete="off">
                    <Row gutter={SEARCH_ITEM_GUTTER} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        <Col style={{ width: '20%' }}>
                            <Form.Item label="起始港" name="start_port_name">
                                <Select
                                    options={createJsonOptions(startPortOptions)}
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '22%' }}>
                            <Form.Item label="目的港" name="end_port_name">
                                <Select
                                    options={createJsonOptions(endPortOptions)}
                                    showSearch
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '22%' }}>
                            <Form.Item label="BookingNumber" name="booking_number">
                                <Input placeholder="" allowClear onPressEnter={handleSearch} />
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '20%' }}>
                            <Space>
                                <Button onClick={handleSearch} type="primary">
                                    搜索
                                </Button>
                                <Button onClick={handleReset}>重置</Button>
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Card>

            <Table
                rowKey={(record) => record.trace_id || record.id || record.option_id || Math.random().toString()}
                bordered
                loading={loading}
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                scroll={{ x: 1800, y: tableScrollY }}
            />
        </div>
    );
}
